import { useCallback } from 'react'

import { Tooltip } from '@/components/primitives/Tooltip'
import { useNavigate } from '@/routing'
import { Button } from '@mui/material'

import { useTexts } from './useTexts'
import { useUserAndTerritoryType } from './useUserAndTerritoryType'

export function GoToSettingsButton() {
  const texts = useTexts()

  const type = useUserAndTerritoryType()
  const navigate = useNavigate<uui.routing.Settings>(true)

  const onClick = useCallback(() => {
    navigate('communication-plan')
  }, [navigate])

  return (
    <Tooltip placement="bottom" title={texts.tooltip(type)} disabled={type === 'rm360Admin'}>
      <Button disabled={type !== 'rm360Admin'} onClick={onClick} variant="outlined">
        {texts.text}
      </Button>
    </Tooltip>
  )
}
